<template>
  <div class="summary-root">
    <div class="summary-title">Puntos Obtenidos</div>
    <hr />
    <table>
      <tbody v-for="(category, index) in categories" :key="category.key">
        <tr>
          <td class="summary-icon-col text-center align-top p-0">
            <CIcon :name="category.icon" size="3xl" class="text-info" />
          </td>
          <td>
            {{ category.label }}
            <br />
            <br />
            <table>
              <tr>
                <td class="summary-link-col text-left font-weight-bold text-info">
                  <a @click="$emit('change-points', category.key)">Ver Detalles</a>
                </td>
                <td class="summary-link-col text-left font-weight-bold text-info">
                  <a @click="$emit('change-shop', category.key)">Canjear</a>
                </td>
              </tr>
            </table>
          </td>
          <td class="summary-points-col text-right font-weight-bold text-info">
            {{ (points[category.pointsKey] || 0) | number }}
          </td>
        </tr>
        <tr :key="`divider-${category.key}`" v-if="index < categories.length">
          <td colspan="3">
            <hr />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'RewardsSummary',
  props: {
    points: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      categories: [
        { key: 'event', pointsKey: 'event_points', icon: 'cil-calendar', label: 'Puntos para Eventos y Conciertos' },
        { key: 'card', pointsKey: 'card_points', icon: 'cil-credit-card', label: 'Puntos para Certificados Digitales' },
        { key: 'gift', pointsKey: 'gift_points', icon: 'cil-briefcase', label: 'Puntos para Premios en Especie' },
        { key: 'wallet', pointsKey: 'wallet_points', icon: 'cil-money', label: 'Puntos para Depósitos en Monederos' }
      ]
    }
  }
}
</script>

<style scoped>
.summary-root {
  font-size: 12px;
}

.summary-title {
  font-size: 14px;
  font-weight: bold;
}

.summary-icon-col {
  width: 65px;
}

.summary-link-col {
  width: 100px;
}

.summary-points-col {
  width: 80px;
  font-size: 18px;
}
</style>
